import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Navbar,
  NavbarBrand,
  Row,
} from 'reactstrap';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { FileContext, IPostMajorityFinancialTracking } from './FileContext';
import {
  DomainContext,
  FILE_TYPE_POST_MAJORITY_SUPPORT_SERVICES,
  IPostMajorityFinancialTrackingCategory,
} from '../../contexts/DomainContext';
import { authAxios } from '../../services/AxiosService';
import { notifyError, notifySuccess } from '../../services/ToastService';
import { useParams } from 'react-router';
import { LeavePageConfirm } from '../LeavePageConfirm/LeavePageConfirm';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { disabledSelectStyles } from '../../utils/StylingUtils';
import { RequiredLabel } from '../../components/RequiredLabel';
import { useWindowDimensions } from '../../hooks/WindowHooks';

export const FilePostMajorityFinancialTracking = () => {
  const fileContext = useContext(FileContext);
  const domainContext = useContext(DomainContext);
  const postMajorityFinancialTracking = fileContext.postMajorityFinancialTracking;
  const postMajorityFinancialTrackingCategories = domainContext.postMajorityFinancialTrackingCategories;
  const [changedPostMajorityFinancialTrackingLength, setChangedPostMajorityFinancialTrackingLength] = useState(0);
  const { xs, sm } = useWindowDimensions();
  const mobile = xs || sm;
  const params = useParams<{ fileId: string; tab?: string }>();
  const [isDirty, setIsDirty] = useState(false);
  const [trySave, setTrySave] = useState(false);
  const [isEditingAllowed] = useState(true);

  const submittedToFinanceOptions = [
    { val: true, display: 'Yes' },
    { val: false, display: 'No' },
  ];

  const monthOptions = [
    { val: 'Jan', display: 'Jan' },
    { val: 'Feb', display: 'Feb' },
    { val: 'Mar', display: 'Mar' },
    { val: 'Apr', display: 'Apr' },
    { val: 'May', display: 'May' },
    { val: 'Jun', display: 'Jun' },
    { val: 'Jul', display: 'Jul' },
    { val: 'Aug', display: 'Aug' },
    { val: 'Sep', display: 'Sep' },
    { val: 'Oct', display: 'Oct' },
    { val: 'Nov', display: 'Nov' },
    { val: 'Dec', display: 'Dec' },
  ];

  useEffect(() => {
    if (changedPostMajorityFinancialTrackingLength > 0) {
      var elmt2 = document.getElementById('select-field');
      if (elmt2) {
        elmt2.focus();
        elmt2.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [changedPostMajorityFinancialTrackingLength]);

  const formatCurrencyCommas = (amount: string | undefined) => {
    if (amount) {
      return amount
        .toString()
        .replace(/[, ]+/g, '')
        .replace(/-[^0-9.]/g, '')
        .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
    } else {
      return '';
    }
  };

  const formatCurrencyCommasTwoDigits = (amount: string | undefined) => {
    if (amount) {
      const floatToUse = parseFloat(amount.toString().replace(/[, ]+/g, ''));
      return Number.isNaN(floatToUse)
        ? '0.00'
        : floatToUse
            .toFixed(2)
            .toString()
            .replace(/-[^0-9.]/g, '')
            .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
    } else {
      return '';
    }
  };

  const saveFile = () => {
    if (
      params.fileId &&
      fileContext.fileTypeId &&
      fileContext.stageId &&
      fileContext.createdDate &&
      !postMajorityFinancialTracking.some(
        (f) =>
          !f.postMajorityFinancialTrackingCategoryId ||
          !f.date ||
          !f.month ||
          !f.vendor ||
          !f.paymentType ||
          !f.poNumber ||
          !f.amount
      )
    ) {
      const data = fileContext.getEditData();

      authAxios.post('/api/files/update', data).then((response) => {
        if (response.data.status === 'OK') {
          setIsDirty(false);
          notifySuccess('File updated.');
          fileContext.setFileFromAttributes();
        } else {
          notifyError(response.data.errorMessage);
        }
      });
      let PMData = fileContext.getPostMajoritySupportServicesData(params.fileId);
      PMData.postMajorityFinancialTracking = PMData.postMajorityFinancialTracking?.sort(
        (a: IPostMajorityFinancialTracking, b: IPostMajorityFinancialTracking) => {
          if (a.date && b.date) {
            return a.date - b.date;
          } else {
            if (a.date === 0) {
              return 1;
            }
            if (b.date === 0) {
              return -1;
            }
            return 0;
          }
        }
      );
      authAxios.post('/api/files/update-post-majority-support-services', PMData).then((response) => {
        if (response.data.status === 'OK') {
          console.log('PM updated :)');
        } else {
          console.log('PM not updated :(');
        }
      });
    } else {
      setTrySave(true);
    }
  };

  return (
    <>
      <LeavePageConfirm isDirty={isDirty} />
      <Navbar color={'light'} light={true} expand={'xs'} className={'border-bottom d-flex flex-wrap sticky-top'}>
        <NavbarBrand className={'w-mobile-100'}>Financial Tracking</NavbarBrand>
        <div
          className={'d-flex flex-grow-1 justify-content-end flex-wrap navbar-actions'}
          style={{ rowGap: '0.5rem', columnGap: '0.5rem' }}
        >
          {params.fileId && (
            <Button color={'primary'} className={'w-mobile-100'} onClick={() => saveFile()}>
              Save Financial Tracking
            </Button>
          )}
        </div>
      </Navbar>
      <Container fluid={true} className={'my-3'}>
        <Card>
          <CardHeader className={'d-flex align-items-center'}>Post Majority Financial Tracking</CardHeader>
          <CardBody className={'p-0'}>
            <ListGroup flush={true}>
              <ListGroupItem className={'py-2 d-none d-md-block'}>
                <Row style={{ paddingRight: 42 }} className='row--condensed'>
                  <Col style={{ flexGrow: 1.4 }}>
                    <RequiredLabel
                      required={postMajorityFinancialTracking.some((p) => !p.postMajorityFinancialTrackingCategoryId)}
                    >
                      Category
                    </RequiredLabel>
                  </Col>
                  <Col style={!mobile ? { flexGrow: 0.9, flexShrink: 0, flexBasis: 0 } : {}}>
                    <RequiredLabel required={postMajorityFinancialTracking.some((p) => !p.date)}>Date</RequiredLabel>
                  </Col>
                  <Col style={!mobile ? { flexGrow: 0.8, flexShrink: 0, flexBasis: 0 } : {}}>
                    <RequiredLabel required={postMajorityFinancialTracking.some((p) => !p.month)}>Month</RequiredLabel>
                  </Col>
                  <Col>
                    <RequiredLabel required={postMajorityFinancialTracking.some((p) => !p.vendor)}>
                      Vendor
                    </RequiredLabel>
                  </Col>
                  <Col>
                    <RequiredLabel required={postMajorityFinancialTracking.some((p) => !p.paymentType)}>
                      Payment Type
                    </RequiredLabel>
                  </Col>
                  <Col>
                    <RequiredLabel required={postMajorityFinancialTracking.some((p) => !p.poNumber)}>
                      PO / Cheque #
                    </RequiredLabel>
                  </Col>
                  <Col>
                    <Label>Submitted To Finance</Label>
                  </Col>
                  <Col style={{ flexGrow: 0.7 }}>
                    <RequiredLabel required={postMajorityFinancialTracking.some((p) => !p.amount)}>
                      Amount ($)
                    </RequiredLabel>
                  </Col>
                  <Col>
                    <Label>Expense/Activity</Label>
                  </Col>
                </Row>
              </ListGroupItem>
              {postMajorityFinancialTracking.map((ft, index) => (
                <ListGroupItem key={ft.postMajorityFinancialTrackingId} className={'py-4'}>
                  <div className={'d-flex'}>
                    <div className={'flex-grow-1'}>
                      <Row className={'row--condensed'}>
                        <Col md={'auto'} style={!mobile ? { flexGrow: 1.5, flexShrink: 1, flexBasis: 0 } : {}}>
                          <Label className={'d-md-none'}>Category</Label>
                          <Select
                            styles={disabledSelectStyles}
                            name={'serviceType'}
                            options={postMajorityFinancialTrackingCategories}
                            placeholder={<span className='placeholder'>Select...</span>}
                            value={postMajorityFinancialTrackingCategories.find(
                              (c: IPostMajorityFinancialTrackingCategory) =>
                                c.postMajorityFinancialTrackingCategoryId === ft.postMajorityFinancialTrackingCategoryId
                            )}
                            onChange={(value: any) => {
                              setIsDirty(true);
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  postMajorityFinancialTrackingCategoryId: value
                                    ? value.postMajorityFinancialTrackingCategoryId
                                    : '',
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                            }}
                            getOptionValue={(option: IPostMajorityFinancialTrackingCategory) =>
                              option.postMajorityFinancialTrackingCategoryId
                            }
                            getOptionLabel={(option: IPostMajorityFinancialTrackingCategory) => option.name}
                            isDisabled={!isEditingAllowed}
                            isClearable={true}
                          />
                          {trySave &&
                            !ft.postMajorityFinancialTrackingCategoryId &&
                            fileContext.fileTypeId === FILE_TYPE_POST_MAJORITY_SUPPORT_SERVICES && (
                              <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                            )}
                        </Col>
                        <Col
                          sm={12}
                          md={'auto'}
                          style={!mobile ? { flexGrow: 1, flexShrink: 0, flexBasis: 0, minWidth: 80 } : {}}
                        >
                          <Label className={'d-md-none'}>Date</Label>
                          <DatePicker
                            selected={ft.date ? new Date(ft.date) : undefined}
                            name={'date'}
                            onChange={(date) => {
                              setIsDirty(true);
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  date: date ? date.getTime() : undefined,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                            }}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            isClearable={true}
                            dateFormat='MMM dd, yyyy'
                            dropdownMode='select'
                            className={'date-picker rounded mb-0'}
                            placeholderText={'MMM dd, yyyy'}
                          />
                          {trySave &&
                            !ft.date &&
                            fileContext.fileTypeId === FILE_TYPE_POST_MAJORITY_SUPPORT_SERVICES && (
                              <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                            )}
                        </Col>
                        <Col sm={12} md={'auto'} style={!mobile ? { flexGrow: 0.8, flexShrink: 0, flexBasis: 0 } : {}}>
                          <Label className={'d-md-none'}>Month</Label>
                          <Select
                            styles={disabledSelectStyles}
                            name={'month'}
                            options={monthOptions}
                            placeholder={<span className='placeholder'>Select...</span>}
                            value={monthOptions.find((m: any) => m.val === ft.month)}
                            onChange={(value: any) => {
                              const monthTemp = value?.val;
                              setIsDirty(true);
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  month: monthTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                            }}
                            getOptionValue={(option: any) => option.val}
                            getOptionLabel={(option: any) => option.display}
                          />
                          {trySave &&
                            !ft.month &&
                            fileContext.fileTypeId === FILE_TYPE_POST_MAJORITY_SUPPORT_SERVICES && (
                              <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                            )}
                        </Col>
                        <Col>
                          <Label className={'d-md-none'}>Vendor</Label>
                          <Input
                            type='text'
                            value={ft.vendor}
                            onChange={(e) => {
                              const vendorTemp = e.target.value;
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  vendor: vendorTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                          />
                          {trySave &&
                            !ft.vendor &&
                            fileContext.fileTypeId === FILE_TYPE_POST_MAJORITY_SUPPORT_SERVICES && (
                              <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                            )}
                        </Col>
                        <Col>
                          <Label className={'d-md-none'}>Payment Type</Label>
                          <Input
                            type='text'
                            value={ft.paymentType}
                            onChange={(e) => {
                              const paymentTypeTemp = e.target.value;
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  paymentType: paymentTypeTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                          />
                          {trySave &&
                            !ft.paymentType &&
                            fileContext.fileTypeId === FILE_TYPE_POST_MAJORITY_SUPPORT_SERVICES && (
                              <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                            )}
                        </Col>
                        <Col>
                          <Label className={'d-md-none'}>PO / Cheque #</Label>
                          <Input
                            type='text'
                            value={ft.poNumber}
                            onChange={(e) => {
                              const poNumberTemp = e.target.value;
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  poNumber: poNumberTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                          />
                          {trySave &&
                            !ft.poNumber &&
                            fileContext.fileTypeId === FILE_TYPE_POST_MAJORITY_SUPPORT_SERVICES && (
                              <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                            )}
                        </Col>
                        <Col>
                          <Label className={'d-md-none'}>Submitted To Finance</Label>
                          <Select
                            styles={disabledSelectStyles}
                            name={'serviceType'}
                            options={submittedToFinanceOptions}
                            placeholder={<span className='placeholder'>Select...</span>}
                            value={submittedToFinanceOptions.find((g) => g.val === ft.submittedToFinance)}
                            onChange={(value: any) => {
                              const submittedToFinance = value?.val;
                              setIsDirty(true);
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  submittedToFinance: submittedToFinance,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                            }}
                            getOptionValue={(option: any) => option.val}
                            getOptionLabel={(option: any) => option.display}
                          />
                        </Col>
                        <Col sm={12} md={'auto'} style={!mobile ? { flexGrow: 0.75, flexShrink: 1, flexBasis: 0 } : {}}>
                          <Label className={'d-md-none'}>Amount ($)</Label>
                          <Input
                            type='text'
                            style={{ textAlign: 'right' }}
                            value={ft.amount}
                            onChange={(e) => {
                              const pAmount = e.target.value;
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  amount: formatCurrencyCommas(pAmount),
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                            onBlur={(e) => {
                              const pAmount = e.target.value;
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  amount: formatCurrencyCommasTwoDigits(pAmount),
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                            disabled={!isEditingAllowed}
                          />
                          {trySave && !ft.amount && (
                            <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>
                          )}
                        </Col>
                        <Col>
                          <Label className={'d-md-none'}>Expense/Activity</Label>
                          <Input
                            type='text'
                            value={ft.expenseOrActivity}
                            onChange={(e) => {
                              const expenseOrActivityTemp = e.target.value;
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  expenseOrActivity: expenseOrActivityTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className={'pt-md-3'}>
                        <Col xs={12}>
                          <Label className={'d-md-none'}>Justification</Label>
                          <Input
                            type={'textarea'}
                            placeholder='Type justification here...'
                            value={ft.justification}
                            style={{ minHeight: '38px', height: '38px' }}
                            onChange={(e) => {
                              const justificationTemp = e.target.value;
                              fileContext.setPostMajorityFinancialTracking((oldFT) => [
                                ...oldFT.slice(0, index),
                                {
                                  ...oldFT[index],
                                  justification: justificationTemp,
                                },
                                ...oldFT.slice(index + 1),
                              ]);
                              setIsDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className={'d-none d-md-block'} style={{ width: 42 }}>
                      <Button
                        color={'link'}
                        className={'text-danger'}
                        onClick={() => {
                          setIsDirty(true);
                          fileContext.setPostMajorityFinancialTracking((oldFT) => [
                            ...oldFT.slice(0, index),
                            ...oldFT.slice(index + 1),
                          ]);
                        }}
                      >
                        <FaTimes />
                      </Button>
                    </div>
                  </div>
                </ListGroupItem>
              ))}
              <ListGroupItem
                tag={'button'}
                id={'add-new-service'}
                className='border-top'
                onClick={() => {
                  setIsDirty(true);
                  fileContext.setPostMajorityFinancialTracking((oldFT) =>
                    oldFT.concat([
                      {
                        postMajorityFinancialTrackingId: Math.random().toString(),
                        postMajorityFinancialTrackingCategoryId: '',
                        date: 0,
                        month: '',
                        vendor: '',
                        paymentType: '',
                        submittedToFinance: false,
                        expenseOrActivity: '',
                        justification: '',
                        amount: '',
                      },
                    ])
                  );
                  setChangedPostMajorityFinancialTrackingLength((s) => s + 1);
                }}
              >
                <FaPlus /> Add Financial Tracking
              </ListGroupItem>
            </ListGroup>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};
